import { Theme } from "@suraasa/placebo-ui-legacy"
import RecordIcon from "features/Cpat/Assessments/assets/record-icon.svg"
import React from "react"
import { createUseStyles } from "react-jss"
import Webcam from "react-webcam"

type Props = {
  videoRef: React.RefObject<Webcam>
  totalWarnings: number
  maxWarningCount: number
}

const useStyles = createUseStyles((theme: Theme) => ({
  videoFrame: {
    transform: "rotateY(180deg)",
    webkitTransform: "rotateY(180deg)",
    mozTransform: "rotateY(180deg)",
    borderRadius: "8px",
    width: "100%",
  },
  divider: {
    "& hr": {
      backgroundColor: theme.colors.onSurface[200],
    },
  },
  color: {
    color: theme.colors.onSurface[600],
  },
  videoBox: {
    position: "relative",
  },
  box: {
    backgroundColor: "#EFEFF7",
    padding: "10px",
    background: "red",
    resize: "horizontal",
    maxWidth: "100%",
    height: "100%",
    aspectRatio: "4 / 3",
    borderRadius: "8px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  recordIconContainer: {
    position: "absolute",
    top: "12px",
    right: "16px",
    animation: "blink 2s linear infinite",
    [theme.breakpoints.down("xs")]: {
      top: "8px",
      right: "8px",
    },
  },
}))

const CameraPanel = ({ videoRef }: Props) => {
  const classes = useStyles()

  return (
    <div className="grid gap-3 p-1 pt-0 xl:pl-4">
      <div className={classes.videoBox}>
        <Webcam
          className={classes.videoFrame}
          ref={videoRef}
          videoConstraints={{
            facingMode: "user",
          }}
        />
        <img
          src={RecordIcon}
          alt="recordIcon"
          className={classes.recordIconContainer}
        />
      </div>
    </div>
  )
}

export default React.memo(CameraPanel)
